module.exports = __webpack_public_path__ + "static/media/solastalgia-7.48f7e142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solastalgia/solastalgia-7.jpg
// module id = 4432
// module chunks = 15